import { post } from 'axios';
import API from '../../settings/api'
import cookie from 'react-cookies';
import headersWithToken from '../../scripts/helpers/headers.token';

const disableLogout = false;

export async function Up( store, email, password, repeat, redirect, showError ) {

  try {

    const { status, data } = await post( API.sign.up, { email, password, repeat } );

    console.log(`signIn data:`, data);

    if ( status === 200 ) {

      if ( data.success ) {

        cookie.save('token', data.token, { path: '/' });
        redirect();
        
      } else {

        throw( data.error );

      }

    } else {

      throw('Нет соединения с сервером');

    }

  } catch ( err ) {

    console.error( err );
    showError( err );

  }
  
}

export async function In( store, e, p, redirect, showError ) {

  try {

    const { status, data } = await post( API.sign.in, { email: e, password: p } );

    console.log(`signIn data:`, data);

    if ( status === 200 ) {

      if ( data.success ) {

        cookie.save('token', data.token, { path: '/' });
        redirect();
        
      } else {

        throw( data.error );

      }

    } else {

      throw('Нет соединения с сервером');

    }

  } catch ( err ) {

    console.error( err );
    showError( err );

  }
  
}

export async function Check( store, token, isSubscribeNeed = false, navigate = () => {}  ) {

  try {

    const headers = headersWithToken();
    const { status, data } = await post( API.sign.check, {}, { headers } );

    console.log(`check data: ${status}`, data);

    if ( status === 200 && data.success ) {

      const { 

        user_name,
        tariff,
        currency, 
        commission, 
        price_watch_mode,
        time_or_commission_mode,
        wanted_result_rub,
        wanted_result_cny,
        wanted_result_usd,
        wanted_result_eur,
        token_tinkoff_extension

      } = data;

      let newState = { 
        
        user_name,
        user_tariff: tariff,
        currency,
        tariff_comission: commission,
        deal_price_watch_mode: price_watch_mode,
        comission_or_time: time_or_commission_mode,
        wanted_result_rub,
        wanted_result_cny,
        wanted_result_usd,
        wanted_result_eur,
        token_tinkoff_extension
      
      }

      if ( price_watch_mode === null ) {

        newState = {

          ...newState,
          popup_opened: "settings",
          popup_settings_only_save: true

        }

      }

      store.setState( newState );

      if ( isSubscribeNeed && ( !data.tariff?.active ) ) { navigate('/tariff'); }
      
      if ( data.tariff?.active && data.tariff?.id !== 0 && window.location.pathname === "/tariff" ) { navigate('/'); }
      
      return true;
      
    } else {

      throw('');

    }

  } catch ( err ) {

    console.error(`Попытка разлогина из Check:`, err);
    store.actions.sign.Out();
    return false;    

  }
  
}

export async function Out() {

  try {

    if ( disableLogout ) { alert('LogOut'); return;}

    cookie.remove(`token`);
    window.location = "/signin";

  } catch(err) {

  }

}